module.exports = __webpack_public_path__ + "img/memocard-white.5f98ff2f.svg";